import { normalizeOverlayPath, withoutLocalePrefix } from "@/lib/global-overlays";

export type MobileNavKey = "today" | "ask" | "journey";

const NAV_MATCHERS: Record<MobileNavKey, readonly string[]> = {
  today: ["/panchang", "/my-panchang", "/daily-horoscope", "/weekly-rashifal"],
  ask: ["/ai-astrologer", "/free-astrology-chat", "/muft-jyotish-chat", "/chat"],
  // Not /free-kundali: the tab links to /account/ (or the remembered reading),
  // so lighting it on the form page said "you are here" about another page.
  journey: ["/account", "/kundali"],
};

export function isHindiMobileJourney(pathname: string): boolean {
  const path = normalizeOverlayPath(pathname);
  return path === "/hi" || path.startsWith("/hi/");
}

export function isMobileNavItemActive(pathname: string, key: MobileNavKey): boolean {
  const path = withoutLocalePrefix(normalizeOverlayPath(pathname));
  return NAV_MATCHERS[key].some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function mobileNavKeyForPath(pathname: string): MobileNavKey | null {
  return (
    (Object.keys(NAV_MATCHERS) as MobileNavKey[]).find((key) =>
      isMobileNavItemActive(pathname, key)
    ) ?? null
  );
}
